const f = {
  color: {
    text: "#304ddbff",
    bg: "#ffffffff",
    border: {
      default: "#c8d3deff",
      hover: "#abb9c7ff"
    },
    error: "#b83525ff",
    brokenButton: {
      text: "#556575ff",
      icon: "#7e8e9eff"
    },
    downloadAll: {
      icon: "#7e8e9eff",
      iconHover: "#556575ff",
      backgroundHover: "#f1f3f5ff"
    }
  }
};
export {
  f as attachment
};
